import { AfterViewInit, Component, ElementRef, HostListener, Injector, OnInit, QueryList, ViewChildren } from '@angular/core';
import { PagedListingComponentBase, PagedRequestDto } from '../../app/paged-listing-component-base';
import { ShareDataService } from '../../shared/service/share-data.service';
import { DesktopNotificationDto, DesktopNotificationDtoPagedResultDto, NotificationService, NotificationStatusUpdateInputDto } from '../../../openapi';
import { finalize } from 'rxjs/operators';
import { AppComponentBase } from '@app/app-component.base';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.less']
})
export class NotificationComponent extends PagedListingComponentBase<DesktopNotificationDto> implements AppComponentBase, AfterViewInit {
  @ViewChildren('lastItem',{read:ElementRef})
  lastItem: QueryList<ElementRef>;

  toggleNotificationbox: boolean;
  notifications: any=[];
  hasNewNotification: boolean = false;
  public text: String;
  collapsed: boolean;
  observer:any;
  loading:boolean=false;

  protected list(request: PagedRequestDto, pageNumber: number, finishedCallback: Function): void {
    this.getNotifications(request.maxResultCount, request.skipCount,pageNumber);
  }
  protected delete(entity: DesktopNotificationDto): void {
    throw new Error('Method not implemented.');
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.toggleNotificationbox = false;
      this.collapsed = false;
    }
  }

  constructor(private eRef: ElementRef,
    private _notificationsService: NotificationService,
    private shareDataService: ShareDataService,
    injector: Injector) {
    super(injector);
  }

  ngAfterViewInit(){
    //To identify last item in list
    this.lastItem.changes.subscribe((e)=>{
      if(e.last) this.observer.observe(e.last.nativeElement);
    });
  }
  
  registerNotification() {
    this.shareDataService.newMessageReceived.subscribe(result => {
      this.hasNewNotification = true;
      this.notify.info(this.l("NewMessageRecevied"));
    })
  }


  ngOnInit(): void {
    this.registerNotification();
    this.getDataPage(1);
  }

  toggleNitification() {
    if (this.toggleNotificationbox === false) {
      this.notifications = [];
      this.getDataPage(1);
    }
    this.collapsed = !this.collapsed;
    this.toggleNotificationbox = !this.toggleNotificationbox;
  }


  markRead(item: DesktopNotificationDto) {
    if (item.read) {
      //window.open(item.link, "_self");
    }
    else {
      item.read = true;
      const creditUnionInput = <NotificationStatusUpdateInputDto>{};
      creditUnionInput.id = item.id;
      this._notificationsService.apiNotificationReadPost(creditUnionInput).pipe(finalize(() => { })).subscribe(res => {
        //window.open(item.link, "_self");
        this.getDataPage(1)
      });
    }
  }


  getNotifications(maxResultCount: number, skipCount: number,pageNumber:number) {
    this.loading = true;
    this._notificationsService.apiNotificationGet(skipCount,maxResultCount)
      .pipe(
      finalize(() => {
        this.loading = false;
      })
      )
      .subscribe((res: DesktopNotificationDtoPagedResultDto) => {
        if (res) {
          res.items.forEach(element => {
            if (!this.hasNewNotification) {
              this.hasNewNotification = (element.read==false);
            }
            this.notifications.push(element);
          });
          this.showPaging(res.totalCount, pageNumber);
          this.intersectioObserver();
        }
      })
  }

  // Using Intersection Observer to implement infinite scroll
  intersectioObserver(){
    let options = {
      root: document.querySelector('#scrollArea'),
      rootMargin: '0px',
      threshold: 0.5
    }
    
    this.observer = new IntersectionObserver((entries)=>{
      if(entries[0].isIntersecting){
        // console.log("scroll more",this.pageNumber)
        if(this.pageNumber * 10 < this.totalItems)
        {
          this.getDataPage(this.pageNumber+1)
        }

      }
    }, options);
  }

}
